import { Offer } from "../Offer";
import { Plan } from "../Plan";
import { MockPlan } from "./MockPlan";

export class MockOffer implements Offer {
  public uuid: string;
  public formattedPrice: string;
  public plans: Plan[];
  private static INDEX = 0;

  constructor() {
    MockOffer.INDEX++;
    this.uuid = `${MockOffer.INDEX}`;
    this.formattedPrice = `${MockOffer.INDEX}€`;
    this.plans = [new MockPlan()];
  }
}
